module.exports = __webpack_public_path__ + "assets/img/btn-view-all-hover-22f0db77.png";